import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/global.css'
import '@/assets/css/theme/index.css'
import request from "@/utils/request";
import "quill/dist/quill.core.css"

// import cookie from 'js-cookie'

// Vue.prototype.$cookie = cookie
Vue.config.productionTip = false

Vue.prototype.$request = request
Vue.prototype.$baseUrl = process.env.VUE_APP_BASEURL

Vue.use(ElementUI, {size: "small"})

// 注册 wechat-title 指令：动态设置页面 document.title
Vue.directive('wechat-title', {
  inserted: function (el, binding) {
    const title = binding.value;
    if (title) {
      document.title = title;
    }
  },
  update: function (el, binding) {
    const title = binding.value;
    if (title) {
      document.title = title;
    }
  }
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
